import React, { useEffect, useMemo, useRef } from "react";
import { SchedulerColumns } from "./SchedulerColumns";
import { EventList } from "./event/EventList";
import { HorizontalLines } from "./horizontalLines";
import { VeritcalLines } from "./veritcalLines";

import { DateValues } from "./dateValue";
import { CurrentTime } from "./currentTime";
import { addDays, addHours, addMinutes, isBefore, setMinutes, startOfDay } from "date-fns";
import { cn } from "../../shared/utils";

export function weekdayDates(weekStart = 0, startDate, length = 6) {
  const tmpStartDate = startOfDay(startDate);
  // while (tmpStartDate.getDay() !== weekStart) {
  //   tmpStartDate.setDate(tmpStartDate.getDate() - 1);
  // }
  return {
    startDate: tmpStartDate,
    endDate: new Date(tmpStartDate.getTime() + length * 24 * 60 * 60 * 1000),
  };
}

export function getHoursToDisplay(
  startHour,
  endHour,
) {
  const dates = []; 
  let startDate = new Date("1970-01-01").setHours(startHour);
  dates.push(startDate);
  const endDate = new Date("1970-01-01").setHours(endHour);
  while (isBefore(startDate,endDate)) {
    dates.push(addHours(startDate, 1));
    startDate = addHours(startDate, 1);
  }
  return dates;
}
export function getDaysBetweenDates(dateFrom, dateTo) {
  const dates = []; // this is as dayjs date
  let startDate = startOfDay(dateFrom);;

  dates.push(startDate);
  const endDate = startOfDay(dateTo);

  while (isBefore(startDate,endDate)) {
    dates.push(addDays(startDate, 1));
    startDate = addDays(startDate, 1);
  }

  return dates.slice(0, 7);
}
export default function CalenderView(props) {
  const {startDate,endDate} =props
  const container = useRef(null);
  const containerNav = useRef(null);
  const containerOffset = useRef(null);
  const schedulerGrid = useRef(null);
  // const startDate = weekdayDates(0, new Date()).startDate;
  // const endDate = weekdayDates(0, new Date()).endDate;
  const startHour = 0;
  const endHour = 23;
  const usersCellsStopsPerHour = 4;
  const availableTimeslots = null;
  const hours = useMemo(
    () => getHoursToDisplay(startHour || 0, endHour || 23),
    [startHour, endHour]
  );
  const days = useMemo(
    () => getDaysBetweenDates(startDate, endDate),
    [startDate, endDate]
  );
  const numberOfGridStopsPerDay = hours.length * usersCellsStopsPerHour;
  const hourSize = 140;
  return (
    <div
        className={cn("scheduler-wrapper flex  w-full flex-col")}
        style={
          {
            "--one-minute-height": `calc(${hourSize}px/60)`,
            "--gridDefaultSize": `${hourSize}px`,
          } 
        }>

        <div
          ref={container}
          className="bg-white  relative isolate flex h-full flex-auto flex-col">
          <div
             style={{ width: "165%" }}
            className="flex h-full max-w-full flex-none flex-col sm:max-w-none md:max-w-full">
            <DateValues containerNavRef={containerNav} days={days} />
            <div className="relative flex flex-auto">
              <CurrentTime />
              <div className="bg-white  ring-accent border-default sticky left-0 z-10 w-14 flex-none border-l border-r ring-1" />
              <div
                className="grid flex-auto grid-cols-1 grid-rows-1 [--disabled-gradient-background:#F8F9FB] [--disabled-gradient-foreground:#E6E7EB] dark:[--disabled-gradient-background:#262626] dark:[--disabled-gradient-foreground:#393939]"
                >
                <HorizontalLines
                  hours={hours}
                  numberOfGridStopsPerCell={usersCellsStopsPerHour}
                  containerOffsetRef={containerOffset}
                />
                <VeritcalLines days={days} />

                <SchedulerColumns
                  offsetHeight={containerOffset.current?.offsetHeight}
                  gridStopsPerDay={numberOfGridStopsPerDay}>
                  {/*Loop over events per day  */}
                  {days.map((day, i) => {
                    return (
                      <li key={day.toISOString()} className="relative" style={{ gridColumnStart: i + 1 }}>
                        <EventList day={day} eventList={props.events} onSelectEventClick={props.onEventClick} />
                        {/* <BlockedList day={day} containerRef={container} /> */}
                      </li>
                    );
                  })}
                </SchedulerColumns>

              </div>
            </div>
          </div>
        </div>
      </div>
  );
}
